import axios, { AxiosInstance } from 'axios'
import { IncomingMessage } from 'http'

const MOSAIC_BASE_URL =
  process.env.GOATENV_ENVIRONMENT === 'production'
    ? 'https://www.goat.com'
    : 'https://staging.goat.com'

export const createMosaicClient = (req: IncomingMessage, locale?: string): AxiosInstance => {
  const acceptLanguage = locale || req.headers['accept-language']

  return axios.create({
    baseURL: MOSAIC_BASE_URL,
    headers: {
      ...(acceptLanguage && { 'accept-language': acceptLanguage }),
    },
  })
}
